<template>
    <div class="opportunity-list">
        <ul uk-accordion="multiple: true">
            <li
                v-for="opp in opportunities"
                :key="sectionName + '-' + opp.id"
                :class="(openPanelByDefault ? 'uk-open ' : '') + 'uk-padding-small uk-padding-remove-left uk-padding-remove-right uk-padding-remove-top'"
            >
                <a
                    class="uk-accordion-title uk-padding-small"
                    href="#"
                >
                    <div
                        v-if="$device.small"
                        class="uk-flex uk-flex-column"
                    >
                        <div>
                            <span>
                                {{ getJobDetailsString(opp) }}
                            </span>
                        </div>
                        <div>
                            {{ opp.build_address }}
                        </div>
                        <div>
                            {{ getNumOfRefunds(opp) }} <span v-if="canUserVerifyRefunds"> {{ getNumOfVerifiedRefunds(opp) }} </span> <span v-else-if="canUserApproveRefunds"> {{ getNumOfApprovedRefunds(opp) }} </span>
                        </div>
                        <div>
                            {{ getAmount(opp) }}
                        </div>
                    </div>
                    <div
                        v-else
                        uk-grid
                    >
                        <div class="uk-width-1-4 uk-padding-remove-left">
                            {{ getJobDetailsString(opp) }}
                        </div>
                        <div class="uk-width-1-3 uk-padding-remove-left">
                            {{ opp.build_address }}
                        </div>
                        <div class="uk-width-1-4">
                            {{ getNumOfRefunds(opp) }} <span v-if="canUserVerifyRefunds"> {{ getNumOfVerifiedRefunds(opp) }} </span> <span v-else-if="canUserApproveRefunds"> {{ getNumOfApprovedRefunds(opp) }} </span>
                        </div>
                        <div class="uk-width-1-6">
                            {{ getAmount(opp) }}
                        </div>
                    </div>
                </a>
                <template v-if="$device.small">
                    <div class="uk-accordion-content uk-margin-remove-top uk-padding-small">
                        <div uk-grid>
                            <div class="uk-overflow-auto">
                                <table>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Name
                                        </th>
                                        <td>:</td>
                                        <td>{{ getBuyerName(opp) }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Total
                                        </th>
                                        <td>:</td>
                                        <td>{{ getAmount(opp) }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Brand
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.salesforce_account_title }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Cancel Reason
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.cancellation_reason }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Site Address
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.build_address }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Consultant
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.consultant }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Manager
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.manager }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Requested By
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.cancellation_initiated_by }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Requested On
                                        </th>
                                        <td>:</td>
                                        <td>{{ convertDateToLocalDate(opp.cancellation_initiated_date) }}</td>
                                    </tr>
                                    <tr v-if="opp.approved_by.length > 0">
                                        <th class="uk-text-uppercase uk-text-small">
                                            Approved By
                                        </th>
                                        <td>:</td>
                                        <td>{{ getApprovedByString(opp) }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="uk-width-1-1">
                                <refund-request-list-table
                                    :opportunity="opp"
                                    :section-name="sectionName"
                                    :is-quick-filter-result="isQuickFilterResult"
                                    :is-refund-request-date-filter-result="isRefundRequestDateFilterResult"
                                    @setPage="setPage"
                                    @approveAll="approveAll"
                                    @rejectAll="rejectAll"
                                    @cancelAll="cancelAll"
                                    @verifyAll="verifyAll"
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="uk-accordion-content uk-margin-remove-top uk-padding-small">
                        <div uk-grid>
                            <div class="uk-width-1-4">
                                <table>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Name
                                        </th>
                                        <td>:</td>
                                        <td>{{ getBuyerName(opp) }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Total
                                        </th>
                                        <td>:</td>
                                        <td>{{ getAmount(opp) }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Brand
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.salesforce_account_title }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Cancel Reason
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.cancellation_reason }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Site Address
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.build_address }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="uk-width-1-4">
                                <table>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Consultant
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.consultant }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Manager
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.manager }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Requested By
                                        </th>
                                        <td>:</td>
                                        <td>{{ opp.cancellation_initiated_by }}</td>
                                    </tr>
                                    <tr>
                                        <th class="uk-text-uppercase uk-text-small">
                                            Requested On
                                        </th>
                                        <td>:</td>
                                        <td>{{ convertDateToLocalDate(opp.cancellation_initiated_date) }}</td>
                                    </tr>
                                    <tr v-if="opp.approved_by.length > 0">
                                        <th class="uk-text-uppercase uk-text-small">
                                            Approved By
                                        </th>
                                        <td>:</td>
                                        <td>{{ getApprovedByString(opp) }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="uk-width-expand">
                                <refund-request-list-table
                                    :opportunity="opp"
                                    :section-name="sectionName"
                                    :is-quick-filter-result="isQuickFilterResult"
                                    :is-refund-request-date-filter-result="isRefundRequestDateFilterResult"
                                    @setPage="setPage"
                                    @approveAll="approveAll"
                                    @rejectAll="rejectAll"
                                    @cancelAll="cancelAll"
                                    @verifyAll="verifyAll"
                                />
                            </div>
                        </div>
                    </div>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import {RefundStatuses} from "../../helpers/constants";
import {convertUtcDateToLocal} from "../../helpers/helpers";

const RefundRequestListTable = () => import("./RefundRequestListTable");

export default {
    name: 'OpportunityList',
    components: { RefundRequestListTable },
    props: {
        opportunities: {
            type: Array,
            default: function () {
                return [];
            }
        },
        sectionName: {
            type: String,
            required: true
        },
        isQuickFilterResult: {
            type: String,
            default: ''
        },
        isRefundRequestDateFilterResult: {
            type: Boolean,
            default: false
        },
        openPanelByDefault: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            canUserVerifyRefunds: 'canUserVerifyRefunds',
            canUserApproveRefunds: 'canUserApproveRefunds',
        }),
    },
    methods: {
        setPage(page) {
            this.$emit('setPage', page);
        },
        approveAll(tokens) {
            return this.$emit('approveAll', tokens);
        },
        verifyAll(tokens) {
            return this.$emit('verifyAll', tokens);
        },
        cancelAll(tokens) {
            return this.$emit('cancelAll', tokens);
        },
        rejectAll(tokens) {
            return this.$emit('rejectAll', tokens);
        },
        getJobDetailsString(opportunity) {
            return '#' + opportunity.job_number + ' (' + this.getBuyerName(opportunity) + ')';
        },
        getBuyerName(opportunity) {
            return [opportunity.buyer_first_name, opportunity.buyer_last_name].join(" ").trim();
        },
        getNumOfRefunds(opportunity) {
            let count = opportunity.refunds.length;
            let unit = (count === 1) ? 'refund' : 'refunds';
            return count + ' ' + unit;
        },
        getNumOfApprovedRefunds(opportunity) {
            let count = opportunity.refunds.filter(item => [RefundStatuses.APPROVED, RefundStatuses.PENDING, RefundStatuses.VERIFIED, RefundStatuses.FINALISED].includes(item.status)).length;
            return '(' + count + ' approved)';
        },
        getNumOfVerifiedRefunds(opportunity) {
            let count = opportunity.refunds.filter(item => [RefundStatuses.VERIFIED, RefundStatuses.FINALISED].includes(item.status)).length;
            return '(' + count + ' verified)';
        },
        getAmount(opportunity) {
            return '$' + opportunity.total_amount;
        },
        convertDateToLocalDate(date) {
            return convertUtcDateToLocal(date, 'dd/LL/yyyy');
        },
        getApprovedByString(opportunity) {
            let approvedBy = opportunity ? opportunity.approved_by : [];
            return approvedBy.join(", ");
        },
    }
}
</script>
